import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";

export const NewJobDialog = ({ open, onOpenChange, onCreate }) => {
  const [name, setName] = useState("");
  const [surveyor, setSurveyor] = useState("");
  const [notes, setNotes] = useState("");

  const submit = async () => {
    if (!name.trim()) return;
    await onCreate({ name: name.trim(), surveyor: surveyor || null, notes: notes || null });
    setName("");
    setSurveyor("");
    setNotes("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="new-job-dialog"
        className="border-[var(--border)] bg-[var(--surface)] text-[var(--text)]"
      >
        <DialogHeader>
          <DialogTitle className="tracking-widest">NEW JOB</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Field label="Name" testid="job-name-input" value={name} onChange={setName} />
          <Field label="Surveyor" testid="job-surveyor-input" value={surveyor} onChange={setSurveyor} />
          <Field label="Notes" testid="job-notes-input" value={notes} onChange={setNotes} />
        </div>
        <DialogFooter>
          <button
            data-testid="job-cancel-btn"
            onClick={() => onOpenChange(false)}
            className="btn-tac !min-h-[44px] px-4 text-sm"
          >
            CANCEL
          </button>
          <button
            data-testid="job-create-btn"
            onClick={submit}
            disabled={!name.trim()}
            className="btn-tac !min-h-[44px] px-4 text-sm"
            data-variant="primary"
          >
            CREATE
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const Field = ({ label, testid, value, onChange }) => (
  <label className="block">
    <span className="mb-1 block text-[10px] uppercase tracking-widest text-[var(--text-dim)]">{label}</span>
    <input
      data-testid={testid}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-sm border border-[var(--border-strong)] bg-[var(--bg)] px-3 py-2 text-base text-[var(--text)] focus:border-[var(--neon)]"
    />
  </label>
);
